import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchLogistics({ payload }) {
  try {
    const res = yield call(API.fetchAllLogisticPartners, payload);
    const { data } = res;
    yield put(actions.fetchLogisticsSuccess(data));
  } catch (err) {
    yield put(actions.fetchLogisticsFailure(err?.response?.data));
  }
}

export function* handleDownload({ payload }) {
  try {
    const { fileName } = payload.data;
    //const res = yield call(API.getDownloadUrl, payload);
    const res = yield call(API.getFileUrl, {
      blobName: fileName,
      source: {
        name: process.env.REACT_APP_ENVIRONMENT,
      },
    });
    const { data } = res;
    const file = yield call(API.downloadFile, {
      url: data.data.document,
      data: "",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(file.data);
    link.setAttribute(
      "download",
      fileName.split("_")[fileName.split("_").length - 1]
    );
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    document.body.removeChild(link);
    yield put(actions.downloadDocumentSuccess({ id: payload.id }));
  } catch (err) {
    yield put(actions.downloadDocumentFailure({ id: payload.id, err }));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* logisticListingSaga() {
  yield takeLatest(actions.fetchLogistics.type, handleFetchLogistics);
  yield takeEvery(actions.downloadDocument.type, handleDownload);
}
